import React, { useState, Fragment, useEffect} from "react";
import axios from "axios";
import axiosInstance from "./../../helpers/axiosInstance";
import { Route, Redirect, useHistory, BrowserRouter, Switch } from "react-router-dom";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Slicer from 'react-slicer';
import 'react-slicer/build/react-slicer.css';
import ReactCircleModal from 'react-circle-modal';
import NumberFormat from "react-number-format";

import {
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Button,
    NavLink,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    CardTitle,
    UncontrolledTooltip,
} from "reactstrap";

import Calendario from "./Calendario";
import {useDispatch} from "react-redux";
import {cambiaruta,cambiasidebar,desactivasidebar} from "../../Slicersreducers";

const Proyeccion=(props)=>{
    console.log(props);
    const [value, onChange] = useState(()=>{
        let newFecha=new Date();
        let fecha400="";
        if(newFecha.getMonth()+1<10){
            fecha400= newFecha.getFullYear() + "0" + (newFecha.getMonth()+1) +fecha400;
        }else{
            fecha400= newFecha.getFullYear() + "" + (newFecha.getMonth()+1)+fecha400;
        }
        if(newFecha.getDate()<10){
            fecha400=fecha400 + "0" + newFecha.getDate();
        }else{
            fecha400=fecha400 + newFecha.getDate();
        }

        return fecha400;
    });
    const [mostrar,setmostrar]=useState(true);
    const [proye,setproye]=useState({
        value: {
            errors: null,
            paymentDate: "",
            balance: "",
            value: "",
            maximunProjection: [
                
            ],
            minimunProjection: [
                
            ]
        },
    });
    const dispacher=useDispatch();
    

    const cambiaFecha=(newFecha)=>{
        let fecha400="";
        if(newFecha.getMonth()+1<10){
            fecha400= newFecha.getFullYear() + "0" + (newFecha.getMonth()+1) +fecha400;
        }else{
            fecha400= newFecha.getFullYear() + "" + (newFecha.getMonth()+1) +fecha400;
        }
        if(newFecha.getDate()<10){
            fecha400=fecha400 + "0" + newFecha.getDate();
        }else{
            fecha400=fecha400 + newFecha.getDate();
        }
        console.log(fecha400);
        onChange(fecha400);
    }

    useEffect(async()=>{
        dispacher(cambiaruta("Inicio/Proyección"))
        dispacher(cambiasidebar(false));
        dispacher(desactivasidebar());
        await postProyectar();
    },props.location.state.accountNumber);



    const postProyectar= async()=>{
        /*if(mostrar){
            setmostrar(false);
        }*/
        console.log("nueva fecha: " + value);
        const user={
            
            AccountNumber : props.location.state.accountNumber,
            Parameters : [ props.location.state.accountNumber,value]
            
        }
        const apiUrl = "/WSGYG39_2/api/Inquiries/Projection";
        const res = await axiosInstance().post(apiUrl, user)
        .catch(err => {
                return 'err';
            });
        if (res != 'err') {
            console.log(res.data);
            setproye(res.data);
        }

    };

    const fecha=()=>{

        if(mostrar){
            setmostrar(false);
        }else{
            setmostrar(true);
        }
    }

    if(props.location.state.accountType=="2" || props.location.state.accountType=="6")
    {
        if(proye?.value?.paymentDate?.length>0){
            console.log(proye.value.paymentDate);
            return (
                <div className="pb-1 pt-1 pt-md-9">
                    <Container fluid>
                            <div className="header-body">
                                <Row className="justify-content-center">
                                    <button onClick={postProyectar} className="btn btn-success">Proyectar</button>
                                    <ReactCircleModal
                                        backgroundColor=""
                                        toogleComponent={onClick => (
                                            <button onClick={onClick} className="btn btn-success">
                                            Elegir fecha de proyección
                                            </button>
                                        )}
                                        // Optional fields and their default values
                                        offsetX={'50%'}
                                        offsetY={'50%'}
                                        
                                        >
                                        {(onClick) => (
                                            <div style={{padding: '1em' }}>
                                            <Calendario muestra={mostrar} cambio={cambiaFecha} className="col-auto"></Calendario>
                                            <button onClick={onClick} className="btn btn-success">
                                                Cerrar calendario
                                            </button>
                                            </div>
                                        )}
                                    </ReactCircleModal>
        
                                </Row>
                                <Row>
                                        <Card className="card-stats shadow mt-2 m-1 w-100 justify-content-center">
                                            <Row>
                                                <Container fluid>
                                                    <div>
                                                        <table className="table table-hover table-bordered table-responsive-md">
                                                            <tbody>
                                                                <tr>
                                                                    <th className="font-weight-bold h2">Fecha de pago: </th>
                                                                    <td className="mb-2 text-sm">
                                                                        {proye.value.paymentDate}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="font-weight-bold h2">Valor Total (Pago Total): </th>
                                                                    <td className="mb-2 text-sm">
                                                                        <NumberFormat value={proye.value.balance} displayType={'text'} thousandSeparator={true} prefix={"$"}/>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="font-weight-bold h2">Valor Total (Pago Mínimo): </th>
                                                                    <td className="mb-2 text-sm">
                                                                       <NumberFormat value={proye.value.value} displayType={'text'} thousandSeparator={true} prefix={"$"}/>   
                                                                    </td>  
                                                                </tr>
        
                                                            </tbody>
                                                            
                                                        </table>
                                                    </div>
                                                </Container>
                                                
                                            </Row>
                                            <Row className="justify-content-center">
                                                <Container fluid>
                                                    <table className="table table-striped table-bordered table-hover table-responsive-md">
                                                        <thead className="bg-success text-uppercase mb-4 text-white font-weight-bold h2" >
                                                            <tr >
                                                                <th>Concepto</th>
                                                                <th style={{textAlign:"right"}}>Pago mínimo</th>
                                                                <th style={{textAlign:"right"}}>Pago total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {proye.value.maximunProjection.map((concep,index)=>{
                                                                return(
                                                                    <tr key={index} >
                                                                        <th className="text-nowrap text-indigo font-weight-bold h2">{concep.nameItem}</th>
                                                                        <td className="mb-2 text-sm" style={{textAlign:"right"}}>
                                                                            <NumberFormat value={proye.value.minimunProjection[index].valueItem} displayType={'text'} thousandSeparator={true} prefix={"$"}/>
                                                                        </td>
                                                                        <td className="mb-2 text-sm"style={{textAlign:"right"}}>
                                                                            <NumberFormat value={concep.valueItem} displayType={'text'} thousandSeparator={true} prefix={"$"}/>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </Container>
                                            </Row>
                                        </Card>
                                </Row>
                            </div>
                    </Container>
                </div>
            )
        }else{
            return(
                <div className="pb-1 pt-1 pt-md-9">
                    <Container fluid>
                            <div className="header-body">
                                <Row className="justify-content-center">
                                    <button onClick={postProyectar} className="btn btn-success">Proyectar</button>
                                    <ReactCircleModal
                                        backgroundColor=""
                                        toogleComponent={onClick => (
                                            <button onClick={onClick} className="btn btn-success">
                                            Elegir fecha de proyección
                                            </button>
                                        )}
                                        // Optional fields and their default values
                                        offsetX={'50%'}
                                        offsetY={'50%'}
                                        
                                        >
                                        {(onClick) => (
                                            <div style={{padding: '1em' }}>
                                            <Calendario muestra={mostrar} cambio={cambiaFecha} className="col-auto"></Calendario>
                                            <button onClick={onClick} className="btn btn-success">
                                                Cerrar calendario
                                            </button>
                                            </div>
                                        )}
                                    </ReactCircleModal>
                                </Row>
                                
                            </div>
                    </Container>
                </div>
    
            );
        }

    }else{
        return (
            <div className="pb-1 pt-1 pt-md-9">
                <Container fluid>
                        <div className="header-body">
                            <Row>
                                    <Card className="card-stats shadow mt-2 m-1 w-100 justify-content-center">
                                        <h2>De este producto no es posible generar proyección</h2>
                                    </Card>
                            
                            </Row>
                        </div>
                </Container>
            </div>
        )
    }
    
    
}

export default Proyeccion;